import { render, staticRenderFns } from "./PostInstructionsHandoverInfo.vue?vue&type=template&id=5c327d8e"
import script from "./PostInstructionsHandoverInfo.vue?vue&type=script&lang=js"
export * from "./PostInstructionsHandoverInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports